module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Polizia-BN.565a21d1.svg";